import formatAmount from '@modules/calculator/utils/formatAmount';
import roundStringValue, { FEE_RATE_PRECISION } from '@modules/calculator/utils/roundStringValue';
export const getDemoCalculatorData = (t, data) => [
    {
        label: t('financing.monthly_payment'),
        value: formatAmount(Number((data === null || data === void 0 ? void 0 : data.monthlyPaymentAmount) || '0')),
        isMonthlyPaymentLimitExceeded: data === null || data === void 0 ? void 0 : data.isMonthlyPaymentLimitExceeded,
    },
    {
        label: t('financing.fixed_annual_interest_rate'),
        value: `${roundStringValue((data === null || data === void 0 ? void 0 : data.annualInterestRate) || '0')}%`,
    },
    {
        label: t('financing.total_repayment'),
        value: formatAmount(Number((data === null || data === void 0 ? void 0 : data.totalRepaymentAmount) || '0')),
    },
    {
        label: t('financing.bvkkmn'),
        value: `${roundStringValue((data === null || data === void 0 ? void 0 : data.annualPercentageRate) || '0')}%`,
    },
    {
        label: t('financing.daily_administration_fee'),
        additionalInfo: `(${t('financing.of_the_remaining_balance')}):`,
        value: `${roundStringValue((data === null || data === void 0 ? void 0 : data.administrationFeeRate) || '0', FEE_RATE_PRECISION)}%`,
    },
];
